export default "__VITE_ASSET__Fl1CAfJ1__"